// app/javascript/controllers/offer_total_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["net", "vat", "gross"]

    connect() {
        this.calculate()
        this.boundHandler = () => this.calculate()
        document.addEventListener("offer:recalculate", this.boundHandler)
    }

    disconnect() {
        document.removeEventListener("offer:recalculate", this.boundHandler)
    }

    calculate() {
        let net = 0
        let gross = 0

        // Wir loopen durch alle aktiven Positionszeilen
        document.querySelectorAll("[data-offer-line-target='net']").forEach(el => {
            // Falls die Zeile per _destroy gelöscht wurde, ignorieren wir sie im Gesamtergebnis
            const row = el.closest(".nested-fields")
            const destroyInput = row ? row.querySelector("input[name*='_destroy']") : null
            if (destroyInput && destroyInput.value === "1") return

            net += parseFloat(el.value) || 0
        })

        document.querySelectorAll("[data-offer-line-target='gross']").forEach(el => {
            const row = el.closest(".nested-fields")
            const destroyInput = row ? row.querySelector("input[name*='_destroy']") : null
            if (destroyInput && destroyInput.value === "1") return

            gross += parseFloat(el.value) || 0
        })

        // Umsatzsteuer kaufmännisch sauber ermitteln
        const vat = Math.max(0, gross - net)

        // Schöne, einheitliche Formatierung im Footer
        this.netTarget.textContent = net.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €"
        this.vatTarget.textContent = vat.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €"
        this.grossTarget.textContent = gross.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €"
    }
}